export function modal() {
 var trigger = $(".c-modal__trigger"),
  wrapper = $(".c-modal__wrapper"),
  layer = $(".c-modal__layer"),
  close = $(".c-modal__close"),
  button = $(".c-modal__button");

 // モーダルを開く
 $(trigger).click(function () {
  var modalId = $(this).data("modal");
  var targetModal = $('.c-modal__wrapper[data-modal="' + modalId + '"]');
  targetModal.fadeIn(400);
  targetModal.find(".c-modal__container").scrollTop(0);
  $("html, body").css("overflow", "hidden");
 });

 // 閉じる処理（背景・×ボタン・戻るボタン）
 $(layer)
  .add(close)
  .add(button) // ← 追加
  .click(function () {
   $(this).closest(".c-modal__wrapper").fadeOut(400);
   $("html, body").removeAttr("style");
  });
}
